module.exports = __locale;